import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "./dialog.css";

import React, { useEffect, useState } from "react";
import Inputs from "../inputs/Inputs";
import MySpinner from "../Spinner/spinner";

const MyDialog = ({
  open,
  onClose,
  width,
  text,
  title,
  submit,
  content,
  height,
  hideSaveButton,
  propBackgroundColor,
  reject,
  rejectText,
  drop,
  dropText,
  approve,
  approveText,
  disbursed,
  disbursedText,
  showLoading,
  payTypeLov = String(text).toLowerCase().includes('oncredit') ? [{ label: "On Credit", value: "oncredit" }] : [
    { label: "Cash", value: "cash" },
    { label: "Bank", value: "bank" }
  ],
  showPayType = false,
  setPayType = (() => {})
}) => {


  const [formValues, setFormValues] = useState({ payType: payTypeLov[0]['value'] });

  useEffect(() => {
    setFormValues({
      ...formValues,
      payType: 'cash'
    })
  },[])

  useEffect(() => {
    if(formValues.payType.length > 0){
      setPayType(formValues.payType)
    }
  },[formValues])

  const handleChange = (event) => {
    //alert(JSON.stringify(event.target))
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={width}>
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent style={{ height: height ?? "" }}>
        <DialogContentText>{content && content()}</DialogContentText>
      </DialogContent>
      <DialogActions>
      {
        showPayType === true && payTypeLov.length > 0 &&
        <div style={{  marginRight: "10px", width: '90px' }}>
        <Inputs
          name="payType"
          size="small"
          label="Pay Type"
          inputType="select"
          defaultValue={payTypeLov[0]['value']}
          listLabel="Pay Type"
          listValue="payType"
          list={payTypeLov}
          onChange={handleChange}          
        />
        </div>
      }
      {hideSaveButton === false && disbursedText && 
        <Inputs
          color="info"
          size="small"
          inputType="button"
          type="submit"
          text={disbursedText ?? "Mark Disbursed"}
          onClick={disbursed}
          propBackgroundColor={propBackgroundColor}
        />
        }
      {hideSaveButton === false && dropText && 
        <Inputs
          color="info"
          size="small"
          inputType="button"
          type="submit"
          text={dropText ?? "Drop Request"}
          onClick={drop}
          propBackgroundColor={"#800000ff"}
        />
        }
        {hideSaveButton === false && text && 
        <Inputs
          color="success"
          size="small"
          inputType="button"
          type="submit"
          text={text ?? "Submit"}
          onClick={submit}
          propBackgroundColor={propBackgroundColor}
        />
        }
        {hideSaveButton === false && approveText && 
        <Inputs
          color="success"
          size="small"
          inputType="button"
          type="submit"
          text={approveText ?? "Approve"}
          onClick={approve}
          propBackgroundColor={propBackgroundColor}
        />
        }
        {hideSaveButton === false && rejectText && 
        <Inputs
          color="info"
          size="small"
          inputType="button"
          type="submit"
          text={rejectText ?? "Send Back"}
          onClick={reject}
          propBackgroundColor={"#800000ff"}
        />
        }
        <Inputs
          color="primary"
          size="small"
          inputType="button"
          text="Close"
          type="submit"
          onClick={onClose}
        />
        {
          showLoading && showLoading === true && <p><MySpinner size={35} color="#367588" /></p>
        }
        
      </DialogActions>
    </Dialog>
  );
};

export default MyDialog;
